import React from 'react';
import RenderMentions from './RenderMentions';
import PostPhotoGallery from 'components/PostPhotoGallery';

interface SocialPostBodyProps {
	content?: string;
	taggedUsers?: any[];
	hashTags?: any[];
	mediaItems?: any[];
	hasMore?: boolean;
	descriptionRef?: React.RefObject<HTMLDivElement>;
	onContentClick?: () => void;
}

const SocialPostBody: React.FC<SocialPostBodyProps> = ({
	content,
	taggedUsers = [],
	hashTags = [],
	mediaItems = [],
	hasMore,
	descriptionRef,
	onContentClick,
}) => {
	return (
		<div className="social-post-body">
			{content && (
				<div className="post-content">
					<p
						className={`description-truncated ${hasMore ? 'has-more' : ''}`}
						ref={descriptionRef}
						onClick={onContentClick}
					>
						<RenderMentions
							content={content}
							taggedUsers={taggedUsers}
							hashTags={hashTags}
							hasMore={hasMore}
							maxLength={200}
						/>
					</p>
				</div>
			)}

			{mediaItems?.length > 0 && <PostPhotoGallery mediaItems={mediaItems} />}
		</div>
	);
};

export default SocialPostBody;
